import { useEffect } from "react";
import news from "../../../assets/images/news.png";
import { Link, useHistory } from "react-router-dom";
import { slugify } from "../../../helpers/utilities";

const ArticlesCountry = ({ props, publicId }) => {
  let articles = props;
  const history = useHistory();

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0); // Scroll to the top of the page when route changes
    });

    return () => {
      unlisten(); // Cleanup the listener when the component unmounts
    };
  }, [history]);

  return (
    <>
      {/* <div className="flex flex-col items-center py-4"> */}
      <div className="flex flex-wrap ">
        {articles?.length == 0 ?
          (
            <div className="mt-4 text-center w-full">
              <p>Articles not found</p>
            </div>
          ) : (
            <>
            {articles?.map((item, index) => (
              <div
                key={index}
                className="flex w-1/3 p-3"
              >
                <div className=" shadow-[0px_0px_8px_0px_#32373926] bg-[#fafafa1f] md:bg-none rounded-lg">
                  <div className="  flex flex-col img-col">
                    <div className="p-4">
                      <img className="w-full" src={news} alt="article" />
                      <h4 className="mt-4 article-title line-clamp-1">
                        {/* {item?.introduction.length > 40
                    ? item?.introduction.substr(0, 39) + "..."
                    : item?.introduction} */}
                        {item?.introduction}
                      </h4>
                      <p className="md:mt-4 mt-2 min-h-[66px] line-clamp-3">
                        {item?.description}
                      </p>
                    </div>

                    <div className="flex p-4 w-full justify-end md:bg-[#f2f2f2]">
                      <Link
                        type="button"
                        to={{
                          pathname: `/articles/${slugify(item.publicId)}`,
                          state: { code: item.publicId, name: item.title },
                        }}
                      >
                        <button
                          type="button"
                          className="px-8 py-2 text-white bg-[#005073] rounded-full flex self-end items-center gap-2"
                        >
                          <p>Lire plus</p>
                          <svg
                            width="16"
                            height="12"
                            viewBox="0 0 16 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.953125 6H13.9335"
                              stroke="white"
                              strokeWidth="1.68421"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                            />
                            <path
                              d="M9.84229 0.947266L14.8125 5.9999L9.84229 11.0525"
                              stroke="white"
                              strokeWidth="1.68421"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>

              </div>
              ))}
              <div className="w-full text-center">
                <button type="button" className="mt-12">
                  <Link
                    // to="/articles"
                    to={{
                      pathname: `/articles`,
                      state: { code: publicId },
                    }}
                  >
                    <span className="text-[#2A5A16] font-bold border-b border-[#2A5A16]">
                      Voir plus d'articles
                    </span>
                  </Link>
                </button>
              </div>
            </>
          )}
      </div>
      {/* </div> */}
    </>
  );
};

export default ArticlesCountry;
